import "leaflet/dist/leaflet.css";
import "react-toastify/dist/ReactToastify.css";
import "loaders.css/loaders.min.css";
import "react-placeholder/lib/reactPlaceholder.css";

/* eslint-disable no-extend-native */
Promise.prototype.finally =
  Promise.prototype.finally ||
  {
    finally(fn) {
      const onFinally = (cb) => Promise.resolve(fn()).then(cb);
      return this.then(
        (result) => onFinally(() => result),
        (reason) =>
          onFinally(() => {
            throw reason;
          })
      );
    },
  }.finally;
/* eslint-enable no-extend-native */
